import React, { useState, useEffect } from "react";
import { Modal, Button, Pagination, Alert, Tooltip, Select } from "antd";
import { FaFileAlt } from "react-icons/fa";
import { useFileManager } from "./useFileManager";
import StatsCards from "./StatsCards";
import FileFilters from "./FileFilters";
import FileTable from "./FileTable";
import DeleteDialog from "./DeleteDialog";

const { Option } = Select;

export default function FileManagerModal({ rutaRelativa, limpiar, rutaActividad }) {
  const [isOpen, setIsOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);

  const {
    files,
    loading,
    error,
    filters,
    setFilters,
    selectedFiles,
    toggleFileSelection,
    toggleAllFiles,
    currentPage,
    setCurrentPage,
    totalPages,
    paginatedFiles,
    stats,
    deleteFiles,
    deleteDialogOpen,
    setDeleteDialogOpen,
    filesToDelete,
    setFilesToDelete,
    refreshFiles,
    usuariosUnicos,
    totalFiles, // Total de archivos filtrados
  } = useFileManager(rutaRelativa, isOpen, limpiar, rutaActividad, pageSize);

  useEffect(() => {
    if (isOpen) refreshFiles();
  }, [isOpen]);

  // Manejar cambio de página
  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    if (size && size !== pageSize) {
      setPageSize(size);
      setCurrentPage(1); // Resetear a primera página cuando cambia el tamaño
    }
  };

  return (
    <>   
      <Tooltip title="Gestión de Archivos">
        <Button
          icon={<FaFileAlt style={{ color: "white", fontSize: 16 }} />}
          onClick={() => setIsOpen(true)}
          style={{
            backgroundColor: "#0966C2",
            border: "none",
            color: "white",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#042A59")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#0966C2")}
        />
      </Tooltip>

      <Modal
        open={isOpen}
        onCancel={() => { setIsOpen(false); }}
        footer={null}
        width="90%"
        title="Gestión de Archivos"
        destroyOnHidden
        style={{ top: 20 }}
      >
        <div className="space-y-6">
          {/* Estadísticas */}
          <StatsCards stats={stats} loading={loading} />

          {/* Filtros */}
          <FileFilters
            filters={filters}
            setFilters={setFilters}
            selectedCount={selectedFiles.size}
            onDeleteSelected={() => {
              const selectedFilesArray = paginatedFiles.filter((file) => selectedFiles.has(file.ruta));
              setFilesToDelete(selectedFilesArray);
              setDeleteDialogOpen(true);
            }}
            disabled={loading}
            availableUsers={usuariosUnicos}
          />

          {/* Error */}
          {error && <Alert message={`Error: ${error}`} type="error" showIcon />}

          {/* Tabla de archivos */}
          <div style={{ 
            overflowY: "auto",
            border: "1px solid #d9d9d9",
            borderRadius: "6px"
          }}>
            <FileTable
              files={paginatedFiles} // Archivos ya paginados
              loading={loading}
              selectedFiles={selectedFiles}
              toggleFileSelection={toggleFileSelection}
              toggleAllFiles={toggleAllFiles}
              onDeleteFile={(file) => {
                setFilesToDelete([file]);
                setDeleteDialogOpen(true);
              }}
              // Quitar la paginación interna de FileTable
              hidePagination={true}
            />
          </div>

          {/* Paginación externa */}
          {!loading && files.length > 0 && (
            <div style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              padding: "16px 0"
            }}>
              <span style={{ color: "#666" }}>
                Mostrando {((currentPage - 1) * pageSize) + 1} - {Math.min(currentPage * pageSize, totalFiles)} de {totalFiles} archivos
              </span>
              
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={totalFiles}
                showSizeChanger
                showQuickJumper
                pageSizeOptions={['10', '20', '30', '50', '100']}
                showTotal={(total, range) => `${range[0]}-${range[1]} de ${total} archivos`}
                onChange={handlePageChange}
                onShowSizeChange={handlePageChange}
              />
            </div>
          )}
        </div>

        {/* Confirmación de eliminación */}
        <DeleteDialog
          open={deleteDialogOpen}
          onOpenChange={setDeleteDialogOpen}
          filesToDelete={filesToDelete}
          onConfirm={deleteFiles}
        />
      </Modal>
    </>
  );
}